import axios from 'axios';
import { CREATE_CITA_REQUEST, CREATE_CITA_SUCCESS, CREATE_CITA_FAILURE } from '../Action-types';

export const crearCita = (citaData) => async (dispatch) => {
  dispatch({ type: CREATE_CITA_REQUEST });

  try {
    const response = await axios.post('/api/citas/create', citaData);

    dispatch({
      type: CREATE_CITA_SUCCESS,
      payload: response.data,
    });

    return response.data; // Retorna la respuesta por si se necesita en el componente
  } catch (error) {
    dispatch({
      type: CREATE_CITA_FAILURE,
      payload: error.response?.data?.message || 'Error al crear la cita',
    });

    throw new Error(error.response?.data?.message || 'Error al crear la cita');
  }
};
